<!--
 * @Author: zhangmh31513
 * @Date: 2021-09-28 15:53:36
 * @LastEditTime: 2021-11-15 17:35:18
 * @LastEditors: zhangmh31513
 * @Description: 视频播放组件，支持视频流和直播流
 * @FilePath: \openplat-web\src\gtn\views\frontViews\developerConference\components\videoCom.vue
 * 有问题请第一时间来联系我
-->
<template>
  <div class="video-player">
    <div class="video-content">
      <!-- 为了能在组件里获取到分类的名称，将maintitle传递下去,如果是直播就传mainTitle，如果是回放就传视频名称 -->
      <NomoralPlayer
        v-if="liveStatus === -1 || liveStatus === 1"
        :videoSrc="sourcesSrc"
        :mainTitle="actived || mainTitle"
        :liveStatus="liveStatus"
        @addPhoton="addPhoton"
      />

      <LivePlayer
        v-else
        :videoSrc="sourcesSrc"
        :mainTitle="actived || mainTitle"
        @addPhoton="addPhoton"
      />
    </div>
    <div class="video-list">
      <div class="vid-list-tit">
        <img
          v-if="mainTitle === '主论坛议程'"
          src="@/assets/developerConference/main-forum-ag.png"
          alt=""
        />
        <div>
          <div class="maintit">{{ mainTitle }}</div>
          <div class="subtit">{{ subTitle }}</div>
        </div>
      </div>
      <div class="vid-list-content">
        <div class="innerbox">
          <div
            class="li-item"
            :class="{ active: item.active === actived && liveStatus === 1 }"
            v-for="(item, index) in timeList"
            :key="'0' + index"
            @click="chooseVideo(item.active, item.video)"
          >
            <img
              v-show="actived === item.active && liveStatus === 1"
              src="@/assets/developerConference/play-icon-selected.png"
              class="play-icon"
              alt="选中态播放按钮"
            />
            <img
              v-show="actived !== item.active && liveStatus === 1"
              class="play-icon"
              src="@/assets/developerConference/play-icon.png"
              alt="默认播放按钮"
            />
            <div class="play-content">
              <div class="play-title">{{ item.active }}</div>
              <div>
                <span class="play-time">{{ item.time }}</span>
                <span class="play-user-name"
                  >{{ item.speaker }} &nbsp; {{ item.position }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 只有有直播地址的时候才会加载聊天室 -->
    <!-- <div class="video-list" v-else>
      <ChatRoom />
    </div> -->
  </div>
</template>

<script>
import NomoralPlayer from "./nomoralPlayer";
import LivePlayer from "./livePlayer";
import { getLiveInfo, completePhotonTask } from "@/api/developerConference.js";
import { mapActions } from "vuex";
// import ChatRoom from "./chatRoom.vue";
export default {
  name: "VideoComponent",
  components: {
    // ChatRoom,
    NomoralPlayer,
    LivePlayer
  },
  props: {
    mainTitle: {
      type: String,
      default: "议程"
    },
    subTitle: {
      type: String,
      default: ""
    },
    timeList: {
      type: Array,
      default: () => []
    },
    areaId: {
      type: Number
    }
  },
  data() {
    return {
      actived: "",
      sourcesSrc: "",
      liveStatus: -1
    };
  },
  watch: {
    areaId: {
      handler: function(nVal, oldVal) {
        this.queryLiveStatus(nVal);
      },
      immediate: true
    }
  },
  computed: {},
  created() {
    this.actived = "";
  },
  mounted() {
    this.actived = "";
  },

  methods: {
    // 切换视频
    chooseVideo(itemId, video) {
      if (this.liveStatus === -1) {
        return;
      }
      if (this.liveStatus === 0) {
        // this.$hMessage.info("直播中无法切换视频");
        return;
      }
      if (this.actived === itemId) return;
      this.actived = itemId;
      // 更换视频地址
      this.sourcesSrc = video;
    },

    /**
     * 描述 查询直播状态
     * @date 2021-11-11
     * 根据论坛id查询当前论坛是否处于直播状态，将直播状态记录，如果是在直播中，则将地址作为当前地址
     * @returns {liveStatus，videoSrc}
     */
    queryLiveStatus(areaId) {
      getLiveInfo(areaId).then(res => {
        // console.log("subgetLiveInfo", res);
        // 既不再直播中，也没有完成直播时，处于未到开播时间段
        this.liveStatus = res.is_start_live ? 0 : res.is_end_live ? 1 : -1;
        if (this.liveStatus === 1) {
          this.actived = this.timeList[0].active;
          this.sourcesSrc = this.timeList[0].video;
        }
        if (this.liveStatus === -1) {
          this.actived = "";
          this.sourcesSrc = "";
        }
        if (res.live_url !== null) {
          this.sourcesSrc = res.live_url;
          this.actived = this.mainTitle;
        }
      });
    },

    //
    ...mapActions(["changeLightData"]),
    addPhoton() {
      const taskType = this.areaId == "7" ? "1" : "2";
      completePhotonTask({ task_id: this.areaId, task_type: taskType }).then(
        res => {
          if (res.member_single_point_amount > 0) {
            this.changeLightData({
              photonNum: res.member_single_point_amount,
              lightShow: true
            });
          }
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.palydev /deep/ .dplayer-notice {
  display: none !important;
}
.palydev {
  width: 100%;
  height: 100%;
}

.video-player {
  width: 1200px;
  position: relative;
  display: flex;
  .video-content {
    width: 97%;
    // background: #dddee2;
    border-radius: 3px;
  }
  .video-list {
    width: 426px;
    background-image: url("../../../../assets/developerConference/video-list-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    margin-left: 20px;
    box-shadow: 4px 4px 8px 0px #d9d9d9;

    .vid-list-tit {
      height: 60px;
      border-radius: 0 3px 0 0;
      font-family: MicrosoftYaHei-Bold;
      font-size: 20px;
      color: #333;
      text-align: center;
      display: flex;
      font-weight: 700;
      align-items: center;
      justify-content: center;
      & img {
        margin-right: 10px;
        width: 24px;
        height: 24px;
      }
      .subtit {
        font-size: 12px;
        font-weight: 400;
        color: #999;
      }
    }

    .vid-list-content {
      height: 426px;
      overflow: hidden;
      // overflow-y: scroll;
      background-image: linear-gradient(
        -46deg,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0.4) 100%
      );
      .innerbox {
        overflow-x: hidden;
        overflow-y: auto;
        height: 100%;
        padding-top: 16px;
      }

      /*滚动条样式*/
      .innerbox::-webkit-scrollbar {
        width: 6px;
      }

      .innerbox::-webkit-scrollbar-thumb {
        border-radius: 10px;
        // -webkit-box-shadow: inset 0 0 5px #cccccc;
        background: #cccccc;
      }

      .innerbox::-webkit-scrollbar-track {
        // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: #fff;
      }

      .li-item {
        padding: 16px;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #666666;
        text-align: left;
        display: flex;
        align-items: center;
        padding-left: 25px;
        cursor: pointer;

        .play-icon {
          width: 18px;
          height: 18px;
        }
        .play-content {
          padding-left: 26px;
          font-size: 16px;
          display: flex;
          flex-direction: column;
          .play-title {
            color: #333;
            margin-bottom: 6px;
          }
          .play-time,
          .play-user-name {
            color: #999;
            line-height: 16px;
          }

          .play-user-name {
            width: 80px;
          }
        }
      }
      .li-item:hover {
        .play-title,
        .play-time,
        .play-user-name {
          color: #1f70fd;
        }
      }
      .active {
        .play-title,
        .play-time,
        .play-user-name {
          color: #1f70fd !important;
        }
        .play-title {
          font-weight: 700;
        }
        background-image: linear-gradient(
          270deg,
          rgba(66, 169, 255, 0) 0%,
          rgba(31, 112, 253, 0.13) 100%
        );
      }
    }
  }
}
</style>
<style lang="scss">
.video-js .vjs-big-play-button {
  left: 50%;
  top: 50%;
  width: 1.5em;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.video-js {
  & .vjs-duration {
    display: block !important;
  }

  & .vjs-current-time {
    display: block !important;
  }
}
.video-js.vjs-paused .vjs-big-play-button {
  /* 视频暂停时显示播放按钮 */
  display: block;
}
.video-js.vjs-error .vjs-big-play-button {
  /* 视频加载出错时隐藏播放按钮 */
  display: none;
}
.vjs-loading-spinner {
  /* 加载圆圈 */
  font-size: 2.5em;
  width: 2em;
  height: 2em;
  border-radius: 1em;
  margin-top: -1em;
  margin-left: -1.5em;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/components/videoCom.vue